import clsx from "clsx";
import type { ReactNode, HTMLAttributes } from "react";
import { forwardRef } from "react";

import styles from "./header.module.css";

type Props = HTMLAttributes<HTMLDivElement> & {
    children: ReactNode;
};

const Header = forwardRef<HTMLDivElement, Props>((props, ref) => {
    const { children, className, ...otherProps } = props;

    return (
        <div {...otherProps} ref={ref} className={clsx(styles.header, className)}>
            {children}
        </div>
    );
});

Header.displayName = "Header";

export { Header };
export type { Props as HeaderProps };
